// extracted by mini-css-extract-plugin
module.exports = {"conditions":"loan_conditions__nouWd","description":"loan_description__qO_4Y","value":"loan_value__Lqdsq","tag":"loan_tag__7uV_8","label":"loan_label__5TdtT"};